var map = {
	"./beat-voices-logo.png": 656,
	"./hero.png": 156,
	"./ss-1.jpg": 936,
	"./ss-2.jpg": 159,
	"./ss-3.jpg": 317,
	"./ss-4.jpg": 185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 698;